
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_wih1l_12o4w_5",
  "tools": "awsui_tools_wih1l_12o4w_14",
  "tools-filtering": "awsui_tools-filtering_wih1l_12o4w_20",
  "tools-align-right": "awsui_tools-align-right_wih1l_12o4w_24",
  "tools-pagination": "awsui_tools-pagination_wih1l_12o4w_28",
  "tools-preferences": "awsui_tools-preferences_wih1l_12o4w_28",
  "tools-small": "awsui_tools-small_wih1l_12o4w_34",
  "table": "awsui_table_wih1l_12o4w_40",
  "table-layout-fixed": "awsui_table-layout-fixed_wih1l_12o4w_46",
  "wrapper": "awsui_wrapper_wih1l_12o4w_50",
  "variant-stacked": "awsui_variant-stacked_wih1l_12o4w_60",
  "variant-container": "awsui_variant-container_wih1l_12o4w_60",
  "variant-embedded": "awsui_variant-embedded_wih1l_12o4w_64",
  "has-header": "awsui_has-header_wih1l_12o4w_67",
  "has-footer": "awsui_has-footer_wih1l_12o4w_70",
  "cell": "awsui_cell_wih1l_12o4w_74",
  "header-cell": "awsui_header-cell_wih1l_12o4w_79",
  "header-cell-sticky": "awsui_header-cell-sticky_wih1l_12o4w_89",
  "header-cell-stuck": "awsui_header-cell-stuck_wih1l_12o4w_92",
  "header-cell-variant-full-page": "awsui_header-cell-variant-full-page_wih1l_12o4w_95",
  "header-cell-sortable": "awsui_header-cell-sortable_wih1l_12o4w_101",
  "body-cell": "awsui_body-cell_wih1l_12o4w_114",
  "body-cell-wrap": "awsui_body-cell-wrap_wih1l_12o4w_122",
  "row": "awsui_row_wih1l_12o4w_135",
  "row-selected": "awsui_row-selected_wih1l_12o4w_141",
  "next-row-selected": "awsui_next-row-selected_wih1l_12o4w_160",
  "cell-merged": "awsui_cell-merged_wih1l_12o4w_189",
  "cell-merged-content": "awsui_cell-merged-content_wih1l_12o4w_193",
  "empty": "awsui_empty_wih1l_12o4w_206",
  "loading": "awsui_loading_wih1l_12o4w_210",
  "selection-control": "awsui_selection-control_wih1l_12o4w_214",
  "sorting-icon": "awsui_sorting-icon_wih1l_12o4w_226",
  "header-cell-disabled": "awsui_header-cell-disabled_wih1l_12o4w_233",
  "header-cell-sorted": "awsui_header-cell-sorted_wih1l_12o4w_233",
  "header-cell-content": "awsui_header-cell-content_wih1l_12o4w_233",
  "header-cell-fake-focus": "awsui_header-cell-fake-focus_wih1l_12o4w_266",
  "header-cell-ascending": "awsui_header-cell-ascending_wih1l_12o4w_295",
  "header-cell-descending": "awsui_header-cell-descending_wih1l_12o4w_296",
  "header-cell-text": "awsui_header-cell-text_wih1l_12o4w_300",
  "header-cell-text-wrap": "awsui_header-cell-text-wrap_wih1l_12o4w_300",
  "sticky-scrollbar": "awsui_sticky-scrollbar_wih1l_12o4w_306",
  "sticky-scrollbar-content": "awsui_sticky-scrollbar-content_wih1l_12o4w_316",
  "sticky-scrollbar-visible": "awsui_sticky-scrollbar-visible_wih1l_12o4w_319",
  "header-secondary": "awsui_header-secondary_wih1l_12o4w_323",
  "header-controls": "awsui_header-controls_wih1l_12o4w_343",
  "thead-active": "awsui_thead-active_wih1l_12o4w_360",
  "divider": "awsui_divider_wih1l_12o4w_364",
  "footer-wrapper": "awsui_footer-wrapper_wih1l_12o4w_371",
  "footer": "awsui_footer_wih1l_12o4w_371"
};
  